import React, { useEffect, useState } from "react";
import "./index.css";
import { Button, Form, Input, notification, Typography, Space, Switch } from "antd";
import { useTranslation } from "react-i18next";
import { useForm } from "antd/es/form/Form";
import { getUser, updateUser, updateUserWithNotification } from "../../../Services/UserProfileServices";
import CommonLayout from "../CommonLayout";
import User_Profile_Header from "../../../Assets/user_profile_header.png";
import { UserRespose } from "../../../redux/Reducer/userReducer";
import { userInformation } from "../../../redux/actions";
import store from "../../../redux/store";
import { EyeInvisibleOutlined, EyeOutlined, MailOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { translation } from "../../../i18n/translationConstant";
import { useFingerprintValidation } from "../../Authentication/FingerprintValidationContext";

const UserProfile: React.FC<{
  setReduxUser: (user: any) => void;
}> = ({ setReduxUser }) => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    vuaId: "",
    email: "",
    sendNotification: false,
  });
  const [changedValues, setChangedValues] = useState({
    firstName: "",
    lastName: "",
  });
  const [isProfileChanged, setIsProfileChanged] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const { t } = useTranslation();
  const [form] = useForm();

  const {checkFingerprint} = useFingerprintValidation();
  
  useEffect(() => {
    getUser().then((res) => setUser(res.data));
    checkFingerprint();
  }, [checkFingerprint]);

  useEffect(() => {
    setChangedValues({
      firstName: user.firstName,
      lastName: user.lastName,
    });

    form.setFieldsValue({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
    });
  }, [user, form]);

  const updateUserInfo = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsProfileChanged(true);
    event.target.id === "firstName"
      ? setChangedValues((old) => ({ ...old, firstName: event.target.value }))
      : setChangedValues((old) => ({ ...old, lastName: event.target.value }));
  };
  const onNameChange = (e: any) => {
    e.target.value = e.target.value.replace(/[^A-Za-z]+/g, "");
  };
  // const updateUserData = (values: any) => {
  //   updateUser(values.firstName, values.lastName).then(() => {
  //     notification.success({
  //       message: t("msgUserProfileSuccess"),
  //     });
  //     setReduxUser({
  //       firstName: changedValues.firstName,
  //       lastName: changedValues.lastName,
  //       mobileNumber: user.mobileNumber,
  //       vuaId: user.vuaId,
  //     });
  //   });
  // };

  const updateUserData = (values: any) => {
    const payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: user.email,
      sendNotification: user.sendNotification,
    };

    updateUserWithNotification(payload).then(() => {
      notification.success({
        message: t("msgUserProfileSuccess"),
      });

      setReduxUser({
        firstName: changedValues.firstName,
        lastName: changedValues.lastName,
        mobileNumber: user.mobileNumber,
        vuaId: user.vuaId,
        email: user.email,
        sendNotification: user.sendNotification,
      });

      setIsProfileChanged(false);
    });
  };

  const [showVuaId, setShowVuaId] = useState(false);
  const [showMobileNumber, setShowMobileNumber] = useState(false);

  return (
    <CommonLayout imageUrl={User_Profile_Header} title={t(translation.lblUserProfile)}>
      <div className="row justifyCenter width60 marginTop30 overflowAuto">
        <Form
          form={form}
          layout="inline"
          name="basic"
          autoComplete="off"
          scrollToFirstError={true}
          onFinish={updateUserData}
        >
          <div className="row justifyCenter ">
            <Form.Item
              className="profileFormItem"
              name="firstName"
              rules={[
                {
                  required: true,
                  message: t("errorRequiredFirstName"),
                },
              ]}
            >
              <div>
                <Typography.Text className={`inputLabels`}>
                  {t("lblFirstName")}
                </Typography.Text>

                <Input
                  className="formInput"
                  onInput={onNameChange}
                  id="firstName"
                  value={changedValues.firstName}
                  onChange={updateUserInfo}
                />
              </div>
            </Form.Item>
            <Form.Item
              className="profileFormItem"
              name="lastName"
              rules={[
                {
                  required: true,
                  message: t("errorRequiredLastName"),
                },
              ]}
            >
              <div>
                <Typography.Text>{t("lblLastName")}</Typography.Text>
                <Input
                  id="lastName"
                  onInput={onNameChange}
                  value={changedValues.lastName}
                  onChange={updateUserInfo}
                  className="formInput"
                />
              </div>
            </Form.Item>
            <Form.Item className="profileFormItem">
              <div>
                <Typography.Text>{t("lblUserName")}</Typography.Text>
                <Input
                  id="vuaid"
                  value={user.vuaId}
                  type={showVuaId ? "text" : "password"} // Set input type to "password" or "text" based on showPassword state
                  readOnly
                  className="formInput"
                  onChange={(e) => setUser({ ...user, vuaId: e.target.value })}
                  onClick={() => setShowVuaId(!showVuaId)}
                />
              </div>
            </Form.Item>
            <Form.Item className="profileFormItem">
              <div>
                <Typography.Text>{t("lblMobileNumber")}</Typography.Text>
                <Input
                  id="mobileNumber"
                  value={user.mobileNumber}
                  type={showMobileNumber ? "text" : "password"} // Set input type to "password" or "text" based on showPassword state
                  className="formInput"
                  readOnly
                  onChange={(e) => setUser({ ...user, mobileNumber: e.target.value })}
                  onClick={() => setShowMobileNumber(!showMobileNumber)}
                />
              </div>
            </Form.Item>

            <Form.Item
              className="profileFormItem fullWidth"
              name="email"
              rules={[
                {
                  type: "email",
                  message: t("lblInvalidEmail"),
                },
                {
                  max: 100,
                  message: t("lblEmailTooLong"),
                },
              ]}
            >
              <div style={{ width: "100%" }}>
                <Typography.Text className="inputLabels">
                  {t("lblEmail")}
                </Typography.Text>

                <Input
                  id="email"
                  value={user.email}
                  placeholder={t("lblEnterEmail")}
                  className={`formInput ${emailError ? "emailErrorInput" : ""}`}
                  onChange={(e) => {
                    setIsProfileChanged(true);

                    const value = e.target.value;

                    setUser((prev) => ({
                      ...prev,
                      email: value,
                    }));

                    form.setFieldValue("email", value);

                    if (value.trim()) {
                      setEmailError(false);
                    }
                  }}
                />

                {emailError && (
                  <Typography.Text className="emailErrorText">
                    Please add email to enable notifications
                  </Typography.Text>
                )}
              </div>
            </Form.Item>
            
            <div className="notificationContainer">
              <Typography.Text className="notificationHeading">
                {t("iblNotifications")}
              </Typography.Text>

              <div className="notificationCard">
                <div className="notificationLeft">
                  <div className="notificationIcon">
                    <MailOutlined />
                  </div>

                  <div className="notificationContent">
                    <Typography.Text className="summaryTitle">
                       {t("iblMonthlyUpdate")}
                    </Typography.Text>

                    <Typography.Text className="summaryDesc">
                       {t("iblMonthlyUpdateRecive")}
                    </Typography.Text>
                  </div>
                </div>

                <Switch
                  checked={user.sendNotification}
                  onChange={(checked) => {
                    if (!user.email?.trim()) {
                      setEmailError(true);
                      return;
                    }

                    setEmailError(false);
                    setIsProfileChanged(true);

                    setUser((prev) => ({
                      ...prev,
                      sendNotification: checked,
                    }));
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row justifyCenter marginTop60 width100 ">
            <Button
              htmlType="submit"
              className="profileSubmitButton"
              disabled={!isProfileChanged}
            >
              {t("lblUpdateDetails")}
            </Button>
          </div>
        </Form>
      </div>
    </CommonLayout>
  );
};

const mapDispatchToProps = () => {
  return {
    setReduxUser: (changedUser: UserRespose) =>
      store.dispatch(userInformation(changedUser)),
  };
};

export default connect(mapDispatchToProps)(UserProfile);
